import React from 'react';
import PropTypes from 'prop-types';
import { Form, Upload } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

function FormDragger({
  name,
  multiple = false,
  beforeUpload = () => false,
  ...rest
}) {
  const { t } = useTranslation();

  const norm = (e) => {
    return multiple ? e?.fileList : e?.file;
  };

  return (
    <Form.Item
      name={name}
      valuePropName={multiple ? 'fileList' : 'file'}
      getValueFromEvent={norm}
      noStyle
    >
      {/* beforeUpload={() => false} allows to post files manually to server */}
      <Upload.Dragger beforeUpload={beforeUpload} multiple={multiple} {...rest}>
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">{t('Vybrať súbor')}</p>
      </Upload.Dragger>
    </Form.Item>
  );
}

FormDragger.propTypes = {
  name: PropTypes.string.isRequired,
  multiple: PropTypes.bool,
  beforeUpload: PropTypes.func,
};

export default FormDragger;
